import React from "react";
import IdleTimer from "react-idle-timer";
import { IDLE_TIME } from "../../../constants/appConstants";
import moment from "moment";

export default function IdleSessionTimer() {
  let idleTimer = null;
  // function onAction(e) {
  // 	console.log("user did something", e);
  // }

  // function onActive() {
  // 	// console.log('user is active', e)
  // }

  function onIdle() {
    //console.log("Idle", idleTimer);
    const lastActive = moment(idleTimer.getLastActiveTime());
    const duration = moment.duration(moment(new Date()).diff(lastActive));
    const min = duration.asMinutes();
    if (min > 57) {
      //console.log("logout diff", min);

      //authContext.logOut();
    } else {
      //console.log("reset diff", min);

      //idleTimer.reset();
      //console.log("remaining diff", idleTimer.getRemainingTime());
    }
  }

  function handleOnActive() {}

  function handleOnAction() {}

  return (
    <IdleTimer
      ref={ref => {
        idleTimer = ref;
      }}
      element={document}
      onActive={handleOnActive}
      onIdle={onIdle}
      onAction={handleOnAction}
      debounce={250}
      timeout={IDLE_TIME} // After 59 minutes it auto log off
    />
  );
}
